var Wallop = require("wallop");
var anime = require("animejs");
var loadTouchEvents = require('jquery-touch-events');
loadTouchEvents($);

var Gallery4 = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

Gallery4.prototype.init = function(){

  var self = this;
  var slider = this.options.$el.find('.Wallop')[0]; // wallop takes a plain JS element, so use [0]
  this.wallop = new Wallop(slider);

  this.options.$el.find(".slider-dots-nav span").on("click", function(){
    var goToSlide = $(this).data("slideIndex");
    self.wallop.goTo(goToSlide);
    self.pauseSlider();
  });

  var slideChange = function(event) {
    var activeSlideNum = event.detail.currentItemIndex;
    self.options.$el.find('.slider-dots-nav span').removeClass('active');
    self.options.$el.find('[data-slide-index=' + activeSlideNum + ']').addClass('active');
  };

  this.wallop.on('change', slideChange);

  // swipe events
  this.options.$el.on('swiperight', function() {
    self.wallop.previous();
    self.pauseSlider();
  });

  this.options.$el.on('swipeleft', function() {
    self.wallop.next();
    self.pauseSlider();
  });

  this.options.$el.find('.play-pause-btn').on('click', function() {
console.log('play button click');
    if ($(this).hasClass('playing'))
    {
      self.options.$el.find('.play-pause-btn').removeClass('playing');
      self.options.$el.find('.play-pause-btn').addClass('paused');
      self.pauseSlider();
    }
    else if ($(this).hasClass('paused'))
    {
      self.options.$el.find('.play-pause-btn').removeClass('paused');
      self.options.$el.find('.play-pause-btn').addClass('playing');
      self.playSlider();
    }

  });

  this.startCountdown();

};

Gallery4.prototype.stopCountdown = function() {

  clearInterval(this.countdownInterval);

};

Gallery4.prototype.startCountdown = function() {

  var self = this;

  this.startCountdownAnimation();
  
  this.countdownInterval = window.setInterval(function() {
    self.wallop.next();
    self.startCountdownAnimation();
  }, 8000);
};

Gallery4.prototype.startCountdownAnimation = function() {

  // reset the animation by removing and re-adding the play/pause button
  var $origEl = this.options.$el.find('.play-pause-btn').first();

  var $newEl = $origEl.clone(true);

  $newEl.removeClass('playing');

  // remove the existing element
  $origEl.remove();

  // add the new element
  this.options.$el.find('.play-pause-btn-wrap').append($newEl);

  // add the playing class to kick off the animation
  this.options.$el.find('.play-pause-btn').addClass('playing');

};

Gallery4.prototype.pauseSlider = function() {
  this.options.$el.find('.play-pause-btn').removeClass('play');
  this.options.$el.find('.play-pause-btn').removeClass('playing');
  this.options.$el.find('.play-pause-btn').addClass('paused');
  this.stopCountdown();
};

Gallery4.prototype.playSlider = function() {
  this.options.$el.find('.play-pause-btn').removeClass('paused');
  this.options.$el.find('.play-pause-btn').addClass('playing');
  this.options.$el.find('.play-pause-btn').addClass('play');
  this.startCountdown();
};

module.exports = Gallery4;
